import { Twelve } from "./Chart.config";
import { fa_time } from "../../Helpers/getWeekDays";
import { redPana } from "../JodiCharts/Chart.config";
import CommonTable from "../../Helpers/CommonTable";
const ShreeDevi = ({ chartData }) => {
    const renderDate = (val) => fa_time(val);

  return (
     <CommonTable
      staticData={Twelve}
      chartData={chartData}
      redJodi={redPana.map((j) => parseInt(j))}
       renderDate={renderDate}
    />
  );
};

export default ShreeDevi;
